<template>
	<div>
		<vs-popup
			:active.sync="showKeywordsIdeasVerifyPopup"
			title="Suggestion de mots clés"
		>
			<div class="space-y-20 text-center">
				<h4>
					Plus vous rentrez de mots clés manuellement et plus la suggestion de
					mots clés sera efficace
				</h4>
				<h5>Souhaitez-vous lancer l’outil de suggestion de mot-clés :</h5>
			</div>
			<div class="text-right space-x-4">
				<vs-button @click="onConfirmShowKeywordsIdeas">Oui</vs-button>
				<vs-button color="danger" @click="showKeywordsIdeasVerifyPopup = false"
					>Non</vs-button
				>
			</div>
		</vs-popup>
		<div v-if="!showKeywordsIdeas" class="flex">
			<vs-button @click="onClickShowKeywordsIdeas"
				>Suggestions de mots-clés</vs-button
			>
		</div>
		<div v-else :key="keywordsKey">
			<div v-if="isloading">Chargement</div>
			<div v-else>
				<vs-table
					:data="keywordsIdeas"
					v-if="keywordsIdeas"
					max-items="10"
					pagination
					multiple
					search
					ref="ref-keywords-ideas-table"
					v-model="choosenKeywords"
					noDataText="Aucun(e) mots-clés."
				>
					<template slot="header">
						<div class="flex space-x-3">
							<h6>Suggestion de mots-clés</h6>
							<vs-tooltip text="Rafraichir la recherche" position="top">
								<vs-icon
									icon="sync"
									size="small"
									class="cursor-pointer"
									@click="fetchKeywordsIdeas"
								></vs-icon>
							</vs-tooltip>
						</div>
					</template>
					<template slot="thead">
						<vs-th>Mots-clés</vs-th>
						<!-- Madame ou Monsieur -->
						<vs-th>CPC</vs-th>
						<vs-th>Volume</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr
							:data="data[indextr]"
							:key="indextr"
							v-for="(tr, indextr) in data"
						>
							<vs-td>{{ data[indextr].keyword }}</vs-td>
							<!-- Madame ou Monsieur -->
							<!--<vs-td v-if="lead_account_manager == data[indextr]"><vs-button @click="deleteAccountManagerLead(data[indextr].id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
							<vs-td class="text-right">{{
								data[indextr].keyword_info.cpc
							}}</vs-td>
							<vs-td class="text-right">
								{{
									Number(
										data[indextr].keyword_info.search_volume
									).toLocaleString("fr-FR")
								}}</vs-td
							>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</div>
	</div>
</template>

<script>
import utilsMixin from "../../../../mixins/utilsMixin";
export default {
	name: "KeywordsIdeasCard",
	props: {
		prospectsSearch: Object,
		keywords: Array,
		language_code: { type: String, default: "fr" },
		location_code: { type: Number, default: 2250 },
		// Your component's props go here
	},
	mixins: [utilsMixin],
	// Your component's logic goes here
	data() {
		return {
			keywordsIdeas: [],
			choosenKeywords: [],
			keywordsKey: 0,
			isloading: false,
			showKeywordsIdeas: false,
			showKeywordsIdeasVerifyPopup: false,
			// Your data properties go here
		};
	},
	watch: {
		choosenKeywords: function (data) {
			this.$emit("click-choose-keyword", data);
		},
	},
	computed: {
		// Your computed properties go here
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	created() {
		// Code to run when the component is created
		// if (this.$props.keywords.length > 0) this.fetchKeywordsIdeas();
		// for (let i = 0; i < this.$props.keywords.length; i++) {
		// 	if (this.$props.keywords[i].keyword_info)
		// 		this.choosenKeywords.push(this.$props.keywords[i]);
		// }
		// this.keywordsKey++;
	},
	updated() {},
	methods: {
		/**Open pop up to verfy to show keywords */
		onClickShowKeywordsIdeas() {
			this.showKeywordsIdeasVerifyPopup = true;
			// this.showKeywordsIdeas = !this.showKeywordsIdeas;
		},
		/** Confirm tos howe keywords */
		onConfirmShowKeywordsIdeas() {
			this.showKeywordsIdeas = true;
			this.showKeywordsIdeasVerifyPopup = false;
			this.fetchKeywordsIdeas();
		},
		fetchKeywordsIdeas() {
			if (this.showKeywordsIdeas) {
				this.isloading = true;
				this.$http
					.post(`/dataforseo/getKeywordsIdeas`, {
						keywords: this.$props.keywords.map((keyword) => keyword.keyword),
						language_code: this.$props.language_code,
						location_code: this.$props.location_code,
					})
					.then((response) => {
						response.data.sort((a, b) => {
							return (
								b.keyword_info.search_volume - a.keyword_info.search_volume
							);
						});
						this.keywordsIdeas = response.data;
						this.isloading = false;
						this.setLoadingRefs(false);
						this.keywordsKey++;
						// Your code here
					})
					.catch((error) => {
						this.isloading = fasle;
						// Your code here
					});
			}
			// Your methods go here
		},
		// Your methods go here
	},
};
</script>

<style scoped>
/* Your component's styles go here */
</style>